import { Modal } from 'react-async-popup';
import '../ui/emergencyPopup.css';
import TicketUpdate from './TicketUpdate';
import ticketService from '../../ticketService';
import TicketUpdateError from './TicketUpdateError';

function convertFileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });
}

const useSendTicketUpdateModal = (ticket, type) => {
  // open modal
  const sendUpdate = async () => {
    const { show } = await Modal.new({
      content: <TicketUpdate ticket={ticket} type={type} />,
      footer: null,
    });
    const result = await show();
    return result;
  };

  return () => {
    return sendUpdate()
      .then((result) => {
        if (!result) throw Error('Skip');
        return result;
      })
      .then(async (dto) => {
        const dtoForBackend = { ...dto };
        if (dtoForBackend.rawFiles !== undefined) {
          const filesAsBase64 = await Promise.all(
            dto.rawFiles.map(async (rawFile) => {
              return {
                file: (await convertFileToBase64(rawFile))?.split(',')[1],
                name: rawFile.name,
              };
            })
          );
          delete dtoForBackend.rawFiles;
          dtoForBackend.files = filesAsBase64;
        }

        return ticketService.callBackend.sendTicketUpdate({ id: ticket.id, dto: dtoForBackend });
      })
      .catch((err) => {
        if (err.message !== 'Skip') throw err;
      })
      .catch((err) => {
        if (isNaN(err.code)) throw err;

        return Modal.new({
          content: <TicketUpdateError ticket={ticket} type={type} />,
          footer: null,
        }).then(({ show }) => show());
      });
  };
};

export default useSendTicketUpdateModal;
